export function getHonorific({ gender, type }) {
  const isFemenino = gender?.toLowerCase() === "femenino";

  if (type === "Médico") {
    return isFemenino ? "Dra." : "Dr.";
  }

  if (type === null) {
    return isFemenino ? "Mtra." : "Mtr.";
  }

  // Si no coincide ningún caso
  return "";
}